import { Component } from '@angular/core';

@Component({
  selector: 'app-site-section-list',
  templateUrl: './site-section-list.component.html',
  styleUrls: ['./site-section-list.component.scss']
})
export class SiteSectionListComponent {

}
